import React, {useEffect, useState} from "react";
import RulesModifyingOptimizationService from "../../../API/details/customer/RulesModifyingOptimizationService";
import {Dialog, DialogActions, DialogContent, DialogTitle, Step, StepLabel, Stepper} from "@mui/material";
import {Box} from "@mui/system";
import RulesModifyingOptimizationTable
    from "../table/optimization/rulesmodifyingoptimization/RulesModifyingOptimizationTable";
import CircularProgress from "@mui/material/CircularProgress";
import ButtonExit from "../button/ButtonExit";
import ButtonAdd from "../button/ButtonAdd";
import ButtonBack from "../button/ButtonBack";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import SelcoFileFieldsService from "../../../API/organization/SelcoFileFieldsService";
import SelcoFileFields from "../../../pages/common/settings/SelcoFileFields";

const modalActions = [
    {name: "Экспорт TXT(Selco)", type: "selco"},
]

const ExportModal = ({modalOpen, handleClose, handleSubmit, handleModalAlert}) => {
    const [selectedType, setSelectedType] = useState(modalActions[0]?.type)
    const [activeStep, setActiveStep] = useState(0)
    const [selectedString, setSelectedString] = useState({})

    const close = () => {
        setActiveStep(0)
        setSelectedString({})
        handleClose()
    }

    return (
        <Dialog open={modalOpen} PaperProps={{
            style: {
                minWidth: `${activeStep === 0 ? "400px" : "700px"}`,
                borderRadius: 8,
            }
        }}>
            <Box style={{
                padding: 20,
                display: "flex",
                flexDirection: "column",
                gap: 16,
                alignItems: "center"
            }}>
                <DialogTitle sx={{
                    color: (theme) => theme.palette.text.main,
                    padding: 0,
                    fontSize: 24,
                    fontWeight: 700
                }}>Экспорт</DialogTitle>
                <Stepper
                    style={{width: 446}}
                    activeStep={activeStep}
                >
                    {["Тип", "Порядок экспорта"].map((label) => (
                        <Step key={label}>
                            <StepLabel sx={{
                                ".MuiSvgIcon-root": {
                                    fontSize: 40,
                                    color: "#737478",
                                    "&.Mui-active": {
                                        color: "#3B8BEC",
                                    }
                                },
                                "& .MuiStepLabel-label": {
                                    fontSize: 18,
                                    "&.Mui-active": {
                                        fontWeight: 700,
                                    }
                                }
                            }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>
            <DialogContent>
                {activeStep === 0 ? <RadioGroup
                    defaultValue="female"
                    aria-labelledby="demo-customized-radios"
                    name="customized-radios"
                    value={selectedType}
                    onChange={(event) => setSelectedType(event.target.value)}
                >
                    {modalActions.map((option) => (
                            <FormControlLabel
                                key={option.type}
                                value={option.type}
                                control={<Radio/>}
                                label={option.name}
                                disabled={option.disabled}
                                sx={{
                                    margin: 0,
                                    height: "36px",
                                    "&:not(:last-of-type)": {
                                        marginBottom: "4px",
                                    },
                                    borderBottom: (theme) => `${theme.palette.primary.stroke} solid 1px`,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light
                                    }
                                }
                                }
                            />
                        )
                    )}
                </RadioGroup> : <SelcoFileFields
                    isModal={true} selectedString={selectedString}
                    setSelectedString={setSelectedString} handleModalAlert={handleModalAlert}/>}
            </DialogContent>
            <DialogActions style={{padding: 20, display: "flex", justifyContent: "space-between"}}>
                <Box>{activeStep !== 0 && <ButtonBack text={"Назад"} onClick={() => setActiveStep(0)}/>} </Box>
                <Box>
                    <ButtonExit
                        text={"Выйти"} onClick={close}/>
                    <ButtonAdd
                        text={activeStep === 0 ? "Выбрать" : "Экспортировать"}
                        width={activeStep === 0 ? 117 : 150}
                        onClick={activeStep === 0 ? () => setActiveStep(1) : () => handleSubmit(selectedString?.id, close)}
                        disabled={activeStep === 1 && !selectedString?.id}
                    />
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default ExportModal;